import { JwtHelper } from '../services/jwt-security/jwt.helpher';

export function User() {

  const jwtHelper: JwtHelper =  new JwtHelper();
  return (target: any, key: string) => {

    // Check if the data exist in the local storage
    function exist(dataKey: string) {
      return sessionStorage.hasOwnProperty(dataKey);
    }

    // Get data from local storage
    function get(user: string) {
      return exist(user) ? jwtHelper.decodeToken(sessionStorage.getItem(user)) : null;
    }

    Object.defineProperty(target, key, {
      configurable: false,
      get: () => {
        const user = get('authToken');
        if (user && user.superAdmin && exist('authTokenSecondary')) {
          return Object.assign({ secondary: true }, get('authTokenSecondary'));
        }
        return user;
      }
    });
  };

}
